import { useFormContext, Controller } from 'react-hook-form'
// @mui
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { masks } from 'src/utils/masks'

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string
  mask?: string
}

export default function RHFTextField({ name, mask, helperText, type, ...other }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          onChange={(event) => {
            let value = event.target.value
            if (mask) {
              value = masks[mask](value)
            }
            if (type === 'number') {
              field.onChange(Number(value))
            } else {
              field.onChange(value)
            }
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  )
}
